import { loadCacheFromLocalStorage } from '../../../helpers/localStorage';
export const INITIAL_FILTER_STATE = {
    values: {
        building: '',
        technicianTeam: '',
        territory: '',
        additionalTerritory: '',
        tags: [],
        buildingTags: '',
        accountTags: '',
        workOrderTags: '',
        type: '',
        inspectionStatus: '',
        inspectionType: '',
        visitStatus: '',
        asset: '',
        inspectionStatusKeys: [],
        visitStatusKeys: []
    },
    active: {
        building: true,
        technicianTeam: false,
        territory: false,
        additionalTerritory: false,
        tags: false,
        buildingTags: false,
        accountTags: false,
        workOrderTags: false,
        type: false,
        inspectionStatus: false,
        inspectionType: false,
        visitStatus: false,
        asset: false,
        statuses: false
    }
};
const buildDefaultState = (technicians) => ({
    events: [],
    technicians,
    selectedTechnicianIds: [],
    selectedSubcontractorIds: [],
    errorMessage: '',
    loading: true,
    detailed: false,
    filters: INITIAL_FILTER_STATE,
    unselectedTechs: {},
    view: 'dayGridMonth',
    statuses: { Inspectioncompleted: true, Inspectionpending: true, Visitcomplete: true, Visitpending: true },
    modalOpen: false
});
export const getInitialData = ({ cacheKey, technicians }) => {
    var _a, _b;
    const cache = loadCacheFromLocalStorage(cacheKey);
    if (cacheIsValid(cache, cacheKey)) {
        return Object.assign(Object.assign(Object.assign({}, buildDefaultState(technicians)), cache), { date: cache.date ? new Date(cache.date) : undefined, events: [], technicians, errorMessage: '', loading: true, selectedTechnicianIds: cache.selectedTechnicianIds === 'all' ? [] : (_a = cache.selectedTechnicianIds) !== null && _a !== void 0 ? _a : [], selectedSubcontractorIds: cache.selectedSubcontractorIds === 'all' ? [] : (_b = cache.selectedSubcontractorIds) !== null && _b !== void 0 ? _b : [] });
    }
    return buildDefaultState(technicians);
};
const cacheIsValid = (cache, cacheKey) => {
    if (!cache)
        return false;
    if (cache.unselectedTechs && cache.view && cache.selectedTechnicianIds && cache.selectedSubcontractorIds)
        return true;
    localStorage.removeItem(cacheKey);
    return false;
};
